const MuiButton = {
  variants: [
    {
      props: { variant: 'newPrimary' },
      style: ({ theme }) => ({
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.A800,
        },
        '&:disabled': {
          backgroundColor: theme.palette.neutral.A300,
        },
        borderRadius: '0.5rem',
        padding: '0.75rem 1.5rem',
        textTransform: 'none',
      }),
    },
    {
      props: { variant: 'secondary', color: 'primary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: 8,
        '&:hover': {
          backgroundColor: theme.palette.neutral.A100,
        },
      }),
    },
    {
      props: { variant: 'navlink' },
      style: ({ theme }) => ({
        height: '35px',
        border: '0px',
        '&:hover': {
          backgroundColor: 'transparent',
          transform: 'scale(0.98)',
          '& .MuiTypography-root': {
            color: theme.palette.primary.A700,
          },
        },
      }),
    },
    {
      props: { variant: 'dropDown' },
      style: ({ theme }) => ({
        height: '35px',
        border: '0px',
        '& .MuiButton-endIcon': {
          color: theme.palette.neutral.A700,
        },
        '&:hover': {
          backgroundColor: 'transparent',
          '& .MuiTypography-root': {
            color: theme.palette.primary.A700,
          },
          '& .MuiButton-endIcon': {
            color: theme.palette.primary.A700,
          },
        },
      }),
    },
  ],
};

export default MuiButton;
